// extracted by mini-css-extract-plugin
module.exports = {"cart_wrapper":"Cart_cart_wrapper__3VgXf","cart_product_wrapper":"Cart_cart_product_wrapper__s_XcP"};